
class CodexPlayerHelper {
    static generatePlayerData = () => {

    }

    static generatePlaylistReadable = (playlistData, mediaDatas) => {

        if (!("contents" in playlistData))
            return null;

        var totalTime = 0;

        const result = playlistData.Medias.map((media) => {
            // console.log("media.Duration " + media.Duration)
            media.duration = parseFloat(media.Duration);
            media.start_time = totalTime;
            media.path = media.UploadFile;
            media.type = media.FileType.toLocaleLowerCase();
            totalTime += media.duration;
            // console.log("totalTime " + totalTime)
            return media
        })

        // const result = playlistData.contents.map((data) => {

        //     const matched = mediaDatas.find((mediaDat) => {
        //         return (data.media_id === mediaDat.id)
        //     })

        //     data.duration = Math.floor(data.duration);
        //     data.path = matched.path;

        //     //get type without
        //     const mediaType = matched.type.split("/")[0];
        //     data.type = mediaType;

        //     data.start_time = totalTime;
        //     totalTime += data.duration;

        //     return data;
        // })

        playlistData.contents = result;
        playlistData.total_time = totalTime;
        return playlistData;
    }
}

export default CodexPlayerHelper
